import React from 'react'
import Cards from './card/Cards.jsx'
import AnimatedCarousel from './carousel/AnimatedCarousel.jsx'
import {carosel} from './data.js'

function Slides() {
  return (
      <div>
    <AnimatedCarousel slideImages={carosel}/>
		<Cards/>
				
    </div>
  )
}

export default Slides